import { render, staticRenderFns } from "./ReviewForm.vue?vue&type=template&id=36f06a96&scoped=true"
import script from "./ReviewForm.vue?vue&type=script&lang=js"
export * from "./ReviewForm.vue?vue&type=script&lang=js"
import style0 from "./ReviewForm.vue?vue&type=style&index=0&id=36f06a96&prod&lang=css"
import style1 from "./ReviewForm.vue?vue&type=style&index=1&id=36f06a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f06a96",
  null
  
)

export default component.exports